/* Home page.

   Two things run here: the comparison table's two pages on a phone, and the
   FAQ's accordion, which is nextdev-faq.js line for line. Both carry the
   guards the shipped files carry, so a page holding this section beside
   nextdev-faq binds every question once. */

// The comparison's two pages on a phone. The dots follow the scroll, and a
// tap on one scrolls its column in beside the labels. From 1024 the table
// is whole, nothing scrolls and the dots are not drawn, so this does nothing.
(function () {
  'use strict';

  var ACTIVE = 'nextdev--home__compare-dot--active';

  document.querySelectorAll('[data-nextdev-home-compare]').forEach(function (box) {
    var dotsWrap = box.parentNode.querySelector('[data-nextdev-home-compare-dots]');
    if (!dotsWrap) return;
    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('button'));
    var label = box.querySelector('.nextdev--home__compare-head--label');
    var cols = Array.prototype.slice.call(
      box.querySelectorAll('.nextdev--home__compare-head--ours, .nextdev--home__compare-head--theirs')
    );
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function target(i) {
      return cols[i].offsetLeft - label.offsetWidth;
    }

    function paint() {
      var current = 0;
      var best = Infinity;
      cols.forEach(function (col, i) {
        var d = Math.abs(box.scrollLeft - target(i));
        if (d < best) {
          best = d;
          current = i;
        }
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle(ACTIVE, i === current);
        dot.setAttribute('aria-pressed', i === current ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        if (!cols[i]) return;
        box.scrollTo({ left: target(i), behavior: reduce.matches ? 'auto' : 'smooth' });
      });
    });

    box.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);
    paint();
  });
})();

// The FAQ's own script, product-page/sections/nextdev-faq/nextdev-faq.js,
// line for line.
/* FAQ.

   One question opens at a time on click. The panel animates on max-height, so
   it is measured on open and released to none once the transition lands, and
   an open panel is released again on resize in case the answer reflows. */

(function () {
  'use strict';

  var OPEN_CLASS = 'nextdev--faq__answer--open';
  var openPanels = [];

  function open(head, body, sign) {
    body.classList.add(OPEN_CLASS);
    head.setAttribute('aria-expanded', 'true');
    if (sign) sign.textContent = '−';
    body.style.maxHeight = body.scrollHeight + 'px';
    if (openPanels.indexOf(body) === -1) openPanels.push(body);
    var done = function (e) {
      if (e.propertyName !== 'max-height') return;
      if (body.classList.contains(OPEN_CLASS)) body.style.maxHeight = 'none';
      body.removeEventListener('transitionend', done);
    };
    body.addEventListener('transitionend', done);
  }

  function close(head, body, sign) {
    body.style.maxHeight = body.scrollHeight + 'px';
    void body.offsetHeight;
    body.classList.remove(OPEN_CLASS);
    head.setAttribute('aria-expanded', 'false');
    if (sign) sign.textContent = '+';
    body.style.maxHeight = '0px';
    var i = openPanels.indexOf(body);
    if (i > -1) openPanels.splice(i, 1);
  }

  function bind(head) {
    var body = head.nextElementSibling;
    if (!body || head.dataset.nextdevFaqInit) return;
    head.dataset.nextdevFaqInit = '1';
    var sign = head.querySelector('.nextdev--faq__sign');
    body.style.maxHeight = '0px';
    head.addEventListener('click', function () {
      if (body.classList.contains(OPEN_CLASS)) {
        close(head, body, sign);
      } else {
        open(head, body, sign);
      }
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-nextdev-faq]').forEach(bind);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      openPanels.forEach(function (body) {
        body.style.maxHeight = 'none';
      });
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // the theme editor swaps the section out and back in
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();